/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroupAssignment } from './UserGroupAssignment';
import {
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentFromJSONTyped,
    UserGroupAssignmentToJSON,
    UserGroupAssignmentToJSONTyped,
} from './UserGroupAssignment';

/**
 * 
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    assignments?: Array<UserGroupAssignment>;
}

/**
 * Check if a given object implements the UserGroup interface.
 */
export function instanceOfUserGroup(value: object): value is UserGroup {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserGroupFromJSON(json: any): UserGroup {
    return UserGroupFromJSONTyped(json, false);
}

export function UserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'assignments': json['assignments'] == null ? undefined : ((json['assignments'] as Array<any>).map(UserGroupAssignmentFromJSON)),
    };
}

export function UserGroupToJSON(json: any): UserGroup {
    return UserGroupToJSONTyped(json, false);
}

export function UserGroupToJSONTyped(value?: UserGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'assignments': value['assignments'] == null ? undefined : ((value['assignments'] as Array<any>).map(UserGroupAssignmentToJSON)),
    };
}

